import styled from 'styled-components';

import { theme } from '_constants/theme';
import { ICONS_ALIASES } from '_constants/icons';

import Icon from '_components/atomic/Icon';

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: ${theme.colors.white};
`;

const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  position: relative;
  overflow: hidden;

  max-width: ${theme.spaces.large30X * 10}px;
  width: 100%;

  padding-top: ${theme.spaces.large19X}px;
  padding-bottom: ${theme.spaces.large19X}px;
  padding-left: ${theme.spaces.large28X - 1}px;
  padding-right: ${theme.spaces.large28X - 1}px;

  @media ${theme.devices.tablet} {
    padding-left: ${theme.spaces.regular}px;
    padding-right: ${theme.spaces.regular}px;
    padding-top: ${theme.spaces.large8X}px;
    padding-bottom: ${theme.spaces.large8X}px;
  }
`;

const StyledLabel = styled.div`
  padding-left: ${theme.spaces.regular - 2}px;
  padding-right: ${theme.spaces.regular - 2}px;
  padding-top: ${theme.spaces.smallest}px;
  padding-bottom: ${theme.spaces.smallest}px;
  margin-bottom: ${theme.spaces.large}px;

  border-radius: 66px;
  background: #f9f5ff;

  font-family: 'Inter';
  font-size: ${theme.fontSizes.regular}px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.03em;
  color: ${theme.colors.indigo.primary};
`;

const StyledTitle = styled.div`
  width: 60%;
  margin-bottom: ${theme.spaces.large}px;
  font-family: 'Inter';
  font-size: ${theme.fontSizes.large8X}px;
  font-weight: 600;
  line-height: 39.6px;
  letter-spacing: -0.03em;
  text-align: left;
  background: linear-gradient(270.46deg, #101828 47.44%, #6941c6 102.37%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media ${theme.devices.tablet} {
    width: 100%;
    font-size: ${theme.fontSizes.large4X}px;
    line-height: 30.8px;
  }
`;

const StyledText = styled.div`
  width: 55%;
  margin-bottom: ${theme.spaces.large}px;
  font-family: 'Inter';
  font-size: ${theme.fontSizes.large}px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.03em;
  text-align: left;
  color: ${theme.colors.gray.secondary};

  @media ${theme.devices.tablet} {
    width: 100%;
  }
`;

const StyledCardsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${theme.spaces.large11X}px;
  padding-top: ${theme.spaces.large + 2}px;

  @media ${theme.devices.tablet} {
    flex-direction: column;
    gap: ${theme.spaces.large}px;
  }
`;

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const StyledCardIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${theme.spaces.medium}px;
  padding: ${theme.spaces.medium / 2 - 2}px;
  border-radius: 10px;
  border: 1px solid #e0d4fe;
  box-shadow: 0px 1px 2px 0px #1018280d, 0px 14px 60px 0px #6941c633;
`;

const StyledCardTitle = styled.div`
  margin-bottom: ${theme.spaces.medium}px;
  font-family: 'Inter';
  font-size: ${theme.fontSizes.large}px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.03em;
  color: ${theme.colors.gray.primary};
`;

const StyledCardText = styled.div`
  margin-bottom: ${theme.spaces.medium}px;
  font-family: 'Inter';
  font-size: ${theme.fontSizes.regular}px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.03em;
  color: ${theme.colors.gray.secondary};
`;

const AboutValuesSection = () => {
  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <StyledLabel> Our Mission and Values</StyledLabel>
        <StyledTitle>
          At Monexa, our mission is to empower businesses and individuals with
          financial clarity and peace of mind
        </StyledTitle>
        <StyledText>
          We are dedicated to providing exceptional accounting and financial
          services that enable our clients to thrive. Our core values define who
          we are and guide everything we do:
        </StyledText>
        <StyledCardsContainer>
          <StyledCard>
            <StyledCardIconContainer>
              <Icon
                alias={ICONS_ALIASES.love}
                color={theme.colors.indigo.primary}
              />
            </StyledCardIconContainer>
            <StyledCardTitle>Integrity and Ethics</StyledCardTitle>
            <StyledCardText>
              We uphold the highest standards of integrity and ethics in all our
              interactions. Trust and transparency are the cornerstones of our
              client relationships.
            </StyledCardText>
          </StyledCard>
          <StyledCard>
            <StyledCardIconContainer>
              <Icon
                alias={ICONS_ALIASES.layers}
                color={theme.colors.indigo.primary}
              />
            </StyledCardIconContainer>
            <StyledCardTitle>Expertise and Innovation</StyledCardTitle>
            <StyledCardText>
              We continuously invest in our team&apos;s expertise and leverage
              cutting-edge technology to deliver accurate and efficient
              financial solutions that drive success.
            </StyledCardText>
          </StyledCard>
          <StyledCard>
            <StyledCardIconContainer>
              <Icon
                alias={ICONS_ALIASES.people}
                color={theme.colors.indigo.primary}
              />
            </StyledCardIconContainer>
            <StyledCardTitle>Community Engagement</StyledCardTitle>
            <StyledCardText>
              We believe in giving back to the community that supports us. We
              actively engage in philanthropic initiatives to make a positive
              impact beyond our business.
            </StyledCardText>
          </StyledCard>
        </StyledCardsContainer>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default AboutValuesSection;
